/**
 * @generated SignedSource<<7d965e4dddc57086d519f3ad05dd10b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailMovement_detailValues$data = ReadonlyArray<{
  readonly browseUrl: string | null;
  readonly detailKey: string | null;
  readonly " $fragmentType": "PdpSharedDetailMovement_detailValues";
}>;
export type PdpSharedDetailMovement_detailValues$key = ReadonlyArray<{
  readonly " $data"?: PdpSharedDetailMovement_detailValues$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailMovement_detailValues">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedDetailMovement_detailValues",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detailKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    }
  ],
  "type": "PdpDetailValueInterface",
  "abstractKey": "__isPdpDetailValueInterface"
};

(node as any).hash = "c26310e83b1de63f138eaac2753446d8";

export default node;
